import React, {useState} from 'react';
import {Accordion, Button, Card} from "react-bootstrap";
import './RandomTip.css';
import {LIST} from "../data/list";
import {SectionBody} from "../Section/Section";

function getRandomInt(min, max) {
  min = Math.ceil(min);
  max = Math.floor(max);
  return Math.floor(Math.random() * (max - min + 1)) + min;
}

const RandomTip = () => {
  const [showTip, setShowTip] = useState(false);
  const [item, setItem] = useState({});

  const onClick = () => {
    setShowTip(false);
    randomize();
    setTimeout(() => setShowTip(true), 100);
  };

  const randomize = () => {
    const randomSectionIndex = getRandomInt(0, LIST.length -1);
    const randomSection = LIST[randomSectionIndex].list;
    const randomItemIndex = getRandomInt(0, randomSection.length -1);
    setItem(randomSection[randomItemIndex]);
  };

  return <div className="random-tip col-12 col-lg-6 m-auto">
    <Button className="ml-auto mr-auto d-block" onClick={onClick}>🎲 I'm feelin' lucky</Button>
    {showTip && <Accordion className="accordian rotate-in-hor mt-5" defaultActiveKey="0">
        <Card className={`item ${item.idea ? 'enabled' : 'disabled'}`}>
          <Accordion.Toggle as={Card.Header} eventKey={0}>
            <h5>
              {item.header}
              {!item.idea && <span className="coming-soon">Coming Soon</span>}
            </h5>
          </Accordion.Toggle>
          {item.idea && <Accordion.Collapse eventKey={0}>
            <SectionBody {...item} />
          </Accordion.Collapse>}
        </Card>
    </Accordion>}
  </div>
};

export default RandomTip;
